module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "subpage"
  }, [_c('div', {
    staticClass: "pgLeft"
  }, [_vm._v("原文")]), _vm._v(" "), _c('div', {
    staticClass: "pgContent"
  }, [_c('textEditor', {
    ref: "textEditor",
    attrs: {
      "inContent": _vm.params.directoryTextContent,
      "editorId": "editor1"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-3a05c742"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/Enterprise/declare/src/Subpage2.vue
// module id = 1456
// module chunks = 1